<template>
    <div :class="`sm:col-${sm_span || 12} xs:col-${xs_span || 12} md:col-${md_span || 6} lg:col-${lg_span || 4} xl:col-${xl_span || 3} sm:col-offset-${sm_offset || 0} xs:col-offset-${xs_offset || 0} md:col-offset-${md_offset || 0} lg:col-offset-${lg_offset || 0} xl:col-offset-${xl_offset || 0} tw-column`">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'tw-col',
    props: {
        // <768px 响应式栅格数
        xs_span: Number,
        xs_offset: Number,
        // ≥768px 响应式栅格数
        sm_span: Number,
        sm_offset: Number,
        // ≥992px 响应式栅格数
        md_span: Number,
        md_offset: Number,
        // ≥992px 响应式栅格数
        lg_span: Number,
        lg_offset: Number,
        // ≥1920px 响应式栅格数
        xl_span: Number,
        xl_offset: Number,
        // 栅格占据的列数
        span: Number,
        // 栅格左侧的间隔格数
        offset: Number,
        // 栅格向右移动格数
        push: Number,
        // 栅格向左移动格数
        pull: Number,
    }
}
</script>